/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
/* eslint-disable prettier/prettier */
/* eslint-disable no-unneeded-ternary */
import { Input, AfterContentInit, AfterViewInit, Component, ComponentFactoryResolver, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Select } from '@ngxs/store';
import { ISession } from 'projects/common/src/app/interfaces/authentication';
import { IMachineContext } from 'projects/common/src/app/interfaces/machine-context';
import { CacheService, ParameterHandlerService } from 'projects/common/src/app/services';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { ExcelExportService } from 'projects/common/src/app/services/utils/excel-export.service';
import { Observable, Subscription } from 'rxjs';
import { IShift } from 'src/app/modules/core/interfaces';
import { IOutputFilter } from 'src/app/modules/core/interfaces/output-filter';
import { DatePresentationPipe } from 'src/app/modules/core/pipes/date-presentation.pipe';
import { BooleanStateService } from 'src/app/modules/core/services/boolean-state.service';
import { dateToDatetimeString } from 'src/app/modules/core/services/datetime.service';
import { DashboardFacade } from 'src/app/modules/core/store/dashboard/dashboard.facade';
import { DashboardState } from 'src/app/modules/core/store/dashboard/dashboard.state';
import { DateFacade } from 'src/app/modules/core/store/date/date.facade';
import { WrapperHeadedButtonsService } from 'src/app/modules/dashboard/services/dashboard/widget-wrapper-header-buttons.service';
import { WidgetConfigurationService } from '../../services/widget-configuration.service';
import { WidgetBasicComponent } from '../widget-basic/widget-basic.component';
import { WidgetConfigurationModalComponent } from '../widget-configuration-modal/widget-configuration-modal.component';
import { WidgetWrapperComponent } from '../widget-wrapper/widget-wrapper.component';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { distinctUntilChanged, tap } from 'rxjs/operators';
import { LoadingStateService } from '../../services/loading-state.service';

@Component({
  selector: 'app-widget-wrapper-headed',
  templateUrl: './widget-wrapper-headed.component.html',
  styleUrls: ['./widget-wrapper-headed.component.scss'],
  providers: [BooleanStateService],
  animations: [
    trigger('widgetEntrance', [
      transition(
        ':enter',
        [
          style({ opacity: 0, transform: 'translateY(-20px) scale(0.95)' }),
          animate('{{delay}}ms {{duration}}ms ease-out', style({ opacity: 1, transform: 'translateY(0) scale(1)' })),
        ],
        { params: { delay: 100, duration: 1000 } },
      ),
    ]),
    trigger('showHide', [
      state('true', style({ opacity: 1, transform: 'translateY(0) scale(1)', display: 'block' })),
      state('false', style({ opacity: 0, transform: 'translateY(-20px) scale(0.95)', display: 'none' })),
      transition('false => true', [
        style({ display: 'block', opacity: 0, transform: 'translateY(-20px) scale(0.95)' }),
        animate('0ms ease-out', style({ opacity: 1, transform: 'translateY(0) scale(1)' })),
      ]),
      transition('true => false', [animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(-20px) scale(0.95)' }))]),
    ]),
    trigger('showError', [
      state('true', style({ opacity: 1, transform: 'translateY(0) scale(1)', display: 'block' })),
      state('false', style({ opacity: 0, transform: 'translateY(-20px) scale(0.95)', display: 'none' })),
    ]),
    trigger('showNoData', [
      state('true', style({ opacity: 1, transform: 'translateY(0) scale(1)', display: 'block' })),
      state('false', style({ opacity: 0, transform: 'translateY(-20px) scale(0.95)', display: 'none' })),
    ]),
  ],
})
export class WidgetWrapperHeadedComponent extends WidgetWrapperComponent implements AfterViewInit, AfterContentInit, OnDestroy {
  @Select(DashboardState.getIsChangeView) isChangeView$: Observable<boolean>;
  @Select(DashboardState.getIsShowTable) isShowTable$: Observable<boolean>;

  @Input() public visibility: boolean;
  @Input() delayIndex = 0;

  public detail: string;
  public date: string;
  public iconButton: string;

  // to define active button property
  public showChangeView: boolean;
  public showHasTable: boolean;
  public params: IOutputFilter;
  public btnSpinner: boolean;
  public disabledExcelBtn: boolean;
  public noDataVisibility = false;
  public errorVisibility = false;
  public downloadDisable = false;
  public hasViewChange: boolean;

  private stateSubscription: Subscription;
  private readonly MESSAG_LAST_UPDATE = 'last_update_at';
  private dateSubscription: Subscription;
  private widgetUpdateAtSubscription: Subscription;

  constructor(
    private cacheService: CacheService,
    protected componentFactoryResolver: ComponentFactoryResolver,
    protected parameterService: ParameterHandlerService,
    protected textService: LanguageService,
    public widgetConfigurationService: WidgetConfigurationService,
    private modalService: NgbModal,
    private wrapperWidgetButtonsService: WrapperHeadedButtonsService,
    public dashboardFacade: DashboardFacade,
    public dateFacade: DateFacade,
    private _excelExportService: ExcelExportService,
    private _loadingStateService: LoadingStateService,
    private cdr: ChangeDetectorRef,
  ) {
    super(componentFactoryResolver, widgetConfigurationService);
    this.iconButton = 'panel-view-icon';
  }

  public ngAfterViewInit(): void {
    super.ngAfterViewInit();

    this.visibility = true; // 👈 asegurar loading inicial

    const widgetInstance = this.componentRef.instance as WidgetBasicComponent;

    this.widgetUpdateAtSubscription = widgetInstance.updatedAt.subscribe((date: Date) => {
      this.updateAt(dateToDatetimeString(date));
      this.errorVisibility = false;
      this.noDataVisibility = false;
      this._loadingStateService.stop();

      setTimeout(() => {
        this.visibility = false;
      }, 2000);
    });

    widgetInstance.errorOccurred.subscribe(() => {
      this.errorVisibility = true;
      this.noDataVisibility = false;
      this.visibility = false;
    });

    widgetInstance.noData.subscribe(() => {
      this.noDataVisibility = true;
      this.errorVisibility = false;
      this.visibility = false;
    });

    widgetInstance.chartWithoutData$.subscribe((isWithoutData) => {
      this.downloadDisable = isWithoutData;
      this.componentRef.changeDetectorRef.detectChanges();
    });
  }

  public ngAfterContentInit(): void {
    this.showHasTable = this.configuration.rawComponent.hasTable ? false : false;
    this.dateSubscription = this.parameterService.parameterSource.item('date').subscribe((date: string) => {
      this.date = date;
    });

    this.visibility = !!this.visibility;

    this.stateSubscription = this._loadingStateService.loadingSource
      .pipe(
        distinctUntilChanged(),
        tap((show: boolean) => {
          this.visibility = show;
          if (show) {
            this.errorVisibility = false;
            this.noDataVisibility = false;
          }
          this.cdr.detectChanges();
        }),
      )
      .subscribe();
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.dateSubscription) {
      this.dateSubscription.unsubscribe();
    }
    if (this.widgetUpdateAtSubscription) {
      this.widgetUpdateAtSubscription.unsubscribe();
    }

    if (this.stateSubscription) {
      this.stateSubscription.unsubscribe();
    }
  }

  public updateAt(value: string): void {
    const datePresentationPipe = new DatePresentationPipe();
    this.dateFacade.UpdateItemParameterService();
    const time = value.split(' ')[1];
    const dateFormated = datePresentationPipe.transform(value);
    this.detail = this.textService.message(this.MESSAG_LAST_UPDATE, `${dateFormated} ${time}`);
    this.componentRef.changeDetectorRef.detectChanges();
  }

  public openConfigurationModal(): void {
    const modalRef = this.modalService.open(WidgetConfigurationModalComponent, {
      centered: true,
      size: 'lg',
    });

    modalRef.componentInstance.widget = this.configuration.rawComponent;
    modalRef.componentInstance.instanceRef = this.componentRef.instance;
  }

  /**
   * Method to changeViewIcon
   */
  public changeViewClassToggler(): void {
    this.showChangeView = !this.showChangeView;
    this.dashboardFacade.buttonIcon$.subscribe((x) => {
      this.iconButton = x;
    });
    this.dashboardFacade.changeButtonIcon();
    this.dashboardFacade.getIsChangeView(this.showChangeView);
  }

  /**
   * Method to hasTableIcon
   */
  public tableClassToggler(): void {
    this.showHasTable = !this.showHasTable;
    this.dashboardFacade.getIsShowTable(this.configuration.rawComponent, this.showHasTable);
  }

  /**
   * Executes excel download
   */
  public downloadExcel(): void {
    if (this.disabledExcelBtn || (this.noDataVisibility && this.errorVisibility)) {
      return; // No hacer nada si el botón debería estar deshabilitado
    }

    const session = this.cacheService.local('session') as ISession;
    const companyId = session.user.company.id;
    const { zoneId } = this.cacheService.session('selectedZone');
    const shift = this.parameterService.parameters.item('shift').value as IShift;
    const machine = this.parameterService.parameters.item('machine-context').value as IMachineContext;

    this.params = {
      companyId,
      inputDate: this.date,
      machineTypeId: machine.machineTypeId.toString(),
      shiftId: shift.shiftId,
      zoneId,
      orderBy: 1,
    };

    this.btnSpinner = true;
    this.disabledExcelBtn = true;
    this.wrapperWidgetButtonsService.GetWidgetExcel(this.params, this.configuration.rawComponent.endpointExport).subscribe({
      next: (response) => {
        this._excelExportService.exportAsExcel(response, this.configuration.rawComponent.name, null, null, true);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastSuccess();
      },
      error: (error) => {
        console.error(error);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastError();
      },
    });
  }
}
